import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class StudentapiService {

    //  url: string = 'http://localhost/cet_api/index.php';
    // url: string = 'http://52.66.74.47/result_api/index.php';
    // url: string = 'http://3.108.196.231/result_api/index.php';
  // url: string = 'https://results.gbshsegoa.net/result_api/index.php';
  // url: string = 'https://3.108.51.127/test_api/index.php';
  // url: string = 'https://3.108.51.127/result_api/index.php';
  //  url: string = 'https://test.gbshsegoa.net/result_api/index.php';
    // url: string = 'https://www.gbshsegoa.net/result_api/index.php';
    // url: string = 'http://result2.gbshse.net/cet_api/index.php';
    // url: string = 'https://results.gbshsegoa.net/cet_api/index.php';

    // url: string = 'http://localhost/gbshse2023_api/index.php'; //Edited by teja

    url: string = 'https://results.gbshsegoa.net/gbshse2023_api/index.php';//live 2024

    // url: string = 'http://43.204.98.97/gbshse2023_api/index.php';

 constructor(private httpClient: HttpClient) { 
   
 }
 get(endpoint: string, params?: any, reqOpts?: any) {
   if (!reqOpts) {
     reqOpts = {
       params: new HttpParams()
     };
   }
   // Support easy query params for GET requests
   if (params) {
     reqOpts.params = new HttpParams();
     for (let k in params) {
       reqOpts.params = reqOpts.params.set(k, params[k]);
     }
   }
   return this.httpClient.get(this.url + '/' + endpoint, reqOpts);
 }
 post(endpoint: string, body: any,params?: any, reqOpts?: any) {
   if (!reqOpts) {
     reqOpts = {
       params: new HttpParams(),
     };
   }
   // Support easy query params for GET requests
   if (params) {
     reqOpts.params = new HttpParams();
     for (let k in params) {
       reqOpts.params = reqOpts.params.set(k, params[k]);
     }
   }
  // console.log("Body :"+JSON.stringify(body));
    return this.httpClient.post(this.url + endpoint, body, reqOpts);
 
}
put(endpoint: string, body: any, reqOpts?: any) {
 return this.httpClient.put(this.url + '/' + endpoint, body, reqOpts);
}

delete(endpoint: string, reqOpts?: any) {
 return this.httpClient.delete(this.url + '/' + endpoint, reqOpts);
}

patch(endpoint: string, body: any, reqOpts?: any) {
 return this.httpClient.patch(this.url + '/' + endpoint, body, reqOpts);
}


}
